import React from 'react';
import * as styles from './StepToStep.module.scss';
import { IBlockStepToStep } from './IBlocks';
import { GatsbyImage } from "gatsby-plugin-image";
import Carousel from '../ui/Carousel/Carousel';
import classnames from 'classnames';
import ButtonLink from '../ui/Buttons/ButtonLink';

type Props = {
}


export default (props: Props & IBlockStepToStep) => {

    const { title, steps } = props;

    return <>
        <div className="content">
            {title && <h2 className="title">{title}</h2>}
        </div>
        {steps.map((step, index) => (
            <div key={step.title} className={classnames([styles.step, index % 2 ? styles.even : styles.odd ])}>
                <div className={styles.stepTitle}>
                    <span className={styles.stepNumber}>{index <= 10 ? "0" : ""}{index + 1}</span>
                    <h3 className={classnames([styles.stepTitleTitle])}>{step.title}</h3>
                </div>
                <div className={classnames([styles.image])}>
                    <Carousel startIndex={0} variant="fullwidth"
                    subPages={[
                        ...(step.images.map((image, imageKey) => <div key={imageKey}>{image.title ? image.title : image.alt}</div>)),
                    ]}
                    >
                        { [
                            ...(step.images.map((image, imageKey) => <div  key={imageKey} ><GatsbyImage
                                image={image.src.childImageSharp.gatsbyImageData}
                                alt={image.alt}
                                title={image.alt} /></div>)),
                        ]}
                    </Carousel>
                </div>
                
                <div className={styles.stepText}>
                    <p>{step.text}</p>
                    {step.button && <ButtonLink variation="minimal" to={step.button.to}>{step.button.text}</ButtonLink>}
                </div>
            </div>
        ))}
    </>;
}